export const AmericaVancouver = 'America/Vancouver'
export const Zulu = 'Zulu'
